<template>
  <div v-if="shopInfo" class="shop-offers">
    <ShopOffersHeader :shop-info="shopInfo" />
    <div v-if="shopInfo.banner" class="l-container merchant-banner-container">
      <div class="merchant-banner">
        <a :href="shopInfo.banner_click_url" rel="nofollow">
          <img :src="shopInfo.banner" alt="" />
        </a>
      </div>
    </div>
    <ModelNavigation
      :count="{
        offers: count,
        promocodes: promoCount,
      }"
      :active-sections="pageData.shopOffers.navSections"
      :active="activeTab"
      :page-route="pageRoute"
      base-title="Все товары"
      :show-margin-top="false"
      @to-route="toRoute"
    />
    <component
      :is="showComponent"
      ref="infoTab"
      :page-data="pageData"
      :data="data"
      @change-data="(e) => $emit('change-data', e)"
    />
    <ShopInfoTab
      v-if="isBot && activeTab === 'base' && isShopInfo"
      :page-data="pageData"
      :data="data"
    />
  </div>
</template>

<script setup lang="ts">
import ShopOffersHeader from '~/components/shop-offers/ShopOffersHeader.vue';
import offersTab from '~/components/shop-offers/OffersTab.vue';
import promocodesTab from '~/components/shop-offers/promocodes/Promocodes.vue';
import ShopInfoTab from '~/components/shop-offers/shop-info/ShopInfo.vue';
import type { DynamicPageContext, FullShopInfo } from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';
import type { PageDataModel } from '~/interfaces/app';

const resultTab: Record<string, PageDataModel> = {
  base: offersTab,
  promocodes: promocodesTab,
  shopinfo: ShopInfoTab,
};
const props = defineProps({
  data: {
    type: Object as () => DynamicPageContext,
    required: true,
  },
  pageData: {
    type: Object as () => FullShopInfo,
    required: true,
  },
});
const emit = defineEmits(['change-data']);
const route = useRoute();
const globalStore = useGlobalStore();
const showComponent = computed(() => {
  return resultTab[props.pageData.active];
});
const count = computed(() => props.pageData?.total || 0);
const promoCount = computed(() => props.pageData.promocodes?.length || 0);
const shopInfo = ref(props.pageData?.shopOffers?.shopinfo);
const activeTab = ref(props.pageData?.active || 'base');
const pageRoute = ref(
  route.path.endsWith('/') ? route.path.slice(0, -1) : route.path
);
const isBot = computed(() => globalStore.isBot);
const isShopInfo = computed(
  () => props.pageData?.shopOffers?.shopinfo?.legalname
);
const toRoute = (routeName: string) => {
  emit('change-data', {
    key: 'active',
    data: routeName,
  });
  activeTab.value = routeName;
};
if (!props.pageData.products?.length) {
  useHead({
    meta: [
      {
        name: 'robots',
        content: 'noindex, nofollow',
      },
    ],
  });
}
</script>
<style scoped lang="scss">
.shop-offers {
  .model-history {
    padding-top: 48px;
    @include lg-block {
      padding-top: 64px;
    }
  }

  .shop-promocodes {
    padding-top: 24px;
    font-size: 16px;
    line-height: 24px;
    border-top: 1px solid $achromatic-hover;
    display: block;
  }

  .merchant-banner-container {
    font-size: 0;

    .merchant-banner {
      border-radius: 8px;
      overflow: hidden;
      @include lg-block {
        border-radius: 12px;
      }
    }

    img {
      width: 100%;
    }
  }

  .merchant-carousel {
    margin-top: 20px;
    @include md-block {
      margin-top: 28px;
    }
    @include lg-block {
      margin-top: 32px;
    }
    @include xl-block {
      margin-top: 40px;
    }
  }

  :deep(.shop-offers-base) {
    margin-top: 20px;
    @include md-block {
      margin-top: 28px;
    }
    @include lg-block {
      margin-top: 32px;
    }
    @include xl-block {
      margin-top: 40px;
    }

    .header-title-wrap-bc {
      background: none;
      margin-top: 40px;
      padding: 0;
      @include md-block {
        margin-top: 48px;
      }
      @include lg-block {
        margin-top: 64px;
      }
    }

    .products-list {
      .controls,
      .category-products {
        padding-top: 12px;
        @include md-block {
          padding-top: 16px;
        }
        @include lg-block {
          padding-top: 20px;
        }
        @include xl-block {
          padding-top: 28px;
        }
      }
    }
  }

  :deep(.container-navigation) {
    position: relative;
    z-index: 0;
  }
}
</style>
